import "./instrument";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initQueryPersistence } from "./lib/queryPersistence";

// Enable offline-first query cache persistence
initQueryPersistence();

// Expose build time for cache-busting — ensures a unique bundle hash per deploy
declare const __BUILD_TIME__: number;
(window as any).__BUILD_TIME__ = __BUILD_TIME__;

// onRecoverableError fires for concurrent-mode recoverable errors
// (e.g. hydration mismatches). React 18's createRoot only exposes this
// hook — onCaughtError / onUncaughtError ship in React 19. For caught
// errors we rely on the Sentry.ErrorBoundary wrappers; for uncaught
// errors we rely on Sentry's global browserApiErrorsIntegration which
// hooks window.onerror and window.onunhandledrejection automatically.
createRoot(document.getElementById("root")!, {
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(<App />);

// Register service worker and handle update lifecycle
if ("serviceWorker" in navigator) {
  import("virtual:pwa-register")
    .then(({ registerSW }) => {
      registerSW({
        onNeedRefresh() {
          // Dispatch custom event so App can surface the update toast
          window.dispatchEvent(new CustomEvent("pwa-update-available"));
        },
        onOfflineReady() {
          window.dispatchEvent(new CustomEvent("pwa-offline-ready"));
        },
        immediate: true,
      });
    })
    .catch(() => {
      // SW registration unavailable in dev without PWA plugin active
    });
}
